import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { WikiDetailsComponent } from './wiki-details.component';

@NgModule({
  imports: [
    RouterModule.forChild([
      { path: '', component: WikiDetailsComponent }
    ])
  ],
  exports: [RouterModule]
})
export class WikiDetailsRoutingModule { }
